export const COLOR_BLUE = '#002B7E'

export const BRIGHT_COLOR = '#2A6AF1'
export const TextColor = '#002b7e'
export const HiNetTextColor = '#2A6AF1'
export const Color_Golden = 'linear-gradient(90deg, #FBC62F 0%, #FFA200 100%)'
export const BG_FADE_COLOR = '#D9D9D9'
export const FADE_TEXT = '#666666'
export const SILENT_TEXT = '#333333'
export const DANGER_COLOR = '#EB4545'
export const SUCCESS_COLOR = '#57C600'
export const WARNING_COLOR = '#F1AD00'
export const FOOTER_BG_COLOR = '#00285E'

export const HILABS_HI = <span style={{ color: HiNetTextColor }}>Hi</span>

export const GET_COLOR = type => {
  switch (type) {
    case 'success':
      return SUCCESS_COLOR
    case 'warning':
      return WARNING_COLOR
    case 'danger':
      return DANGER_COLOR
    default:
      return BRIGHT_COLOR
  }
}

export const SX_BG_COLOR_ON_IMG = {
  backgroundColor: COLOR_BLUE + '90',
  backgroundBlendMode: 'multiply',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
}
